// @ts-nocheck

import React, { useEffect, useState } from 'react';

/**
 * Allows two animation frames to complete to allow other components to update
 * and re-render before mounting and rendering an expensive `WrappedComponent`.
 */
const deferComponentRender = (WrappedComponent) => {
  return function AnonymousComponent(props) {
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => setShouldRender(true));
      });
    }, []);

    return shouldRender ? <WrappedComponent {...props} /> : null;
  };
};

export default deferComponentRender;
